import "./App.css";
import { Routes, Route } from "react-router-dom";
import Layout from "./Pages/Layout";
import Home from "./Pages/Home";
import ContactUs from "./Pages/ContactUs";
import "./assets/js/jquery.sticky.js";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "react-toastify/dist/ReactToastify.css";
import Clients from "./Pages/Clients";
import Testimonials from "./Pages/Testimonials";
import Career from "./Pages/Career";
import AboutUs from "./Pages/AboutUs";
import BlueHeights from "./Pages/BlueHeights";
import SkyHeights from "./Pages/SkyHeights";
import Home56 from "./Pages/Home@56";
import ZngResidency from "./Pages/ZngResidency";
import NestResidency from "./Pages/NestResidency";
import GalaxiaDreams from "./Pages/GalaxiaDreams";
import PropertyDetails from "./Pages/PropertyDetails";
import Quality from "./Pages/Quality";
import ComingSoon from "./Pages/ComingSoon";
// import ZeeshanGroupHomepage from "./Pages/ZeeshanGroupHomepage";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="clients" element={<Clients />} />
          <Route path="testimonials" element={<Testimonials />} />
          <Route path="career" element={<Career />} />
          <Route path="about-us" element={<AboutUs />} />
          <Route
            path="quality-health-safety-and-environment"
            element={<Quality />}
          />
          <Route path="home@56" element={<Home56 />} />
          <Route path="sky-heights" element={<SkyHeights />} />
          <Route path="blue-heights" element={<BlueHeights />} />
          <Route path="zng-residency" element={<ZngResidency />} />
          <Route path="nest-residency" element={<NestResidency />} />
          <Route path="galaxia-dreams" element={<GalaxiaDreams />} />
          <Route path="/property/:url" element={<PropertyDetails />} />
          <Route path="coming-soon" element={<ComingSoon />} />
        </Route>
        {/* <Route path="/" element={<ZeeshanGroupHomepage />} /> */}
      </Routes>
    </>
  );
}

export default App;
